<template>
	<div class="card card-white flex items-center justify-between space-x-4 min-w-0 ">
		<a :href="user.url" class="text-black dark:text-white flex items-center space-x-4 min-w-0 ">
			<avatar :ava="user.ava" :online="user.is_online" class="w-8 h-8 md:w-12 md:h-12 shrink-0"></avatar>

			<div class="flex flex-col min-w-0 max-w-full">
				<div class="flex items-center gap-2">
					<div class="min-w-0 font-medium truncate">
						{{ user.name }}
					</div>
					<svg-icon
						icon="check-circle-fill"
						v-if="user.is_verified"
						class="w-3 h-3 text-blue-500 shrink-0">
					</svg-icon>
				</div>

				<rating v-if="showRating" :rate="user.rate" class="text-sm"></rating>
			</div>
		</a>
		<div class="shrink-0">
			<subscribe-button-compact
				v-if="currentUser.check() && !isCurrentUser()"
				:compact="true"
				type="user"
				:id="user.id"
				:subscribed="user.subscribed"></subscribe-button-compact>
		</div>
	</div>
</template>
<script>
import User from "../../js/modules/User";
import Avatar from "../partials/Avatar.vue";
import SubscribeButtonCompact from "../partials/SubscribeButtonCompact.vue";

let store;
export default {
	components: {SubscribeButtonCompact, Avatar},
	props: [
		'user',
		'showRating',
	],
	data() {
		return {
			currentUser: new User(),
		};
	},
	methods: {
		isCurrentUser() {
			return this.user.id === this.currentUser.id();
		}
	}
}
</script>
